import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    allRoutes: [],
    trainRoutes: [],
    flightRoutes: [],
    busRoutes: [],
    mixedRoutes: [],
    loading: false,
    headerLoading: false,
    error: null,
};

const travelSlice = createSlice({
    name: 'travel',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
        setHeaderLoading: (state, action) => {
            state.headerLoading = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
        },
        clearRoutes: (state) => {
            state.allRoutes = [];
            state.trainRoutes = [];
            state.flightRoutes = [];
            state.busRoutes = [];
            state.mixedRoutes = [];
            state.error = null;
        },

        addRoutes: (state, action) => {
            const newRoutes = action.payload || [];
            if (!Array.isArray(newRoutes)) return;

            state.allRoutes.push(...newRoutes);

            newRoutes.forEach(route => {
                const nodes = route.nodes || [];
                const routeType = route.route_type;

                // Determine modes present in this route
                let hasFlight = false;
                let hasTrain = false;
                let hasBus = false;
                let isMixed = false;

                // 1. Prioritize route_type from backend if available (1=Train, 2=Flight, 3=Bus, 4=Mixed)
                if (routeType === 1) {
                    hasTrain = true;
                } else if (routeType === 2) {
                    hasFlight = true;
                } else if (routeType === 3) {
                    hasBus = true;
                } else if (routeType === 4) {
                    isMixed = true;
                } else {
                    // 2. Fallback to property-based detection if route_type is missing/unknown
                    nodes.forEach(n => {
                        const seg = n.segment || {};
                        const isFlight = !!(seg.flight_num || (seg.carrier && !seg.train_name));
                        const isTrain = !!(seg.train_name || seg.train_num);
                        const isBus = !!(seg.bus_type || (seg.travel_name && !seg.train_name && !seg.flight_num));

                        if (isFlight) hasFlight = true;
                        if (isTrain) hasTrain = true;
                        if (isBus) hasBus = true;
                    });
                }

                const modesCount = [hasTrain, hasFlight, hasBus].filter(Boolean).length;

                if (isMixed || modesCount > 1) {
                    state.mixedRoutes.push(route);
                } else if (hasTrain) {
                    state.trainRoutes.push(route);
                } else if (hasFlight) {
                    state.flightRoutes.push(route);
                } else if (hasBus) {
                    state.busRoutes.push(route);
                }
            });
        }
    }
});

export const { setLoading, setHeaderLoading, setError, clearRoutes, addRoutes } = travelSlice.actions;

// Selectors
export const selectAllRoutes = (state) => state.travel.allRoutes;
export const selectTrainRoutes = (state) => state.travel.trainRoutes;
export const selectFlightRoutes = (state) => state.travel.flightRoutes;
export const selectMixedRoutes = (state) => state.travel.mixedRoutes;
export const selectBusRoutes = (state) => state.travel.busRoutes;
export const selectTravelLoading = (state) => state.travel.loading;
export const selectHeaderLoading = (state) => state.travel.headerLoading;
export const selectTravelError = (state) => state.travel.error;

export default travelSlice.reducer;
